const NAVBAR_HEIGHT = 58;

export default NAVBAR_HEIGHT;
